export default __webpack_public_path__ + "static/media/Icon-ionic-md-stats.a1497598.svg";